import { Component, Vue } from "vue-property-decorator";

export interface RelayCapabilities {
	// output ("Pulse") vs door ("Momentary Unlock")
	isOutput: boolean;
	canPulse: boolean;
	canOnOff: boolean;
}

// settingsMeta casing varies across the product (e.g. <RelayType>Output</RelayType>), so match case-insensitively.
export function parseRelayCapabilities(settingsMeta: string | null | undefined): RelayCapabilities {
	const meta = (settingsMeta || "").toLowerCase();

	return {
		isOutput: meta.includes("<relaytype>output</relaytype>"),
		canPulse: meta.includes("<featurepulse/>"),
		canOnOff: meta.includes("<featureonoff>1</featureonoff>")
	};
}

// Component wrapper so templates/components can share parseRelayCapabilities.
@Component
export default class RelayCapabilitiesMixin extends Vue {
	public getRelayCapabilities(settingsMeta: string | null | undefined): RelayCapabilities {
		return parseRelayCapabilities(settingsMeta);
	}
}
